module.exports = __webpack_public_path__ + "static/media/bg-header-STILLES.1e52db7b.png";